import PropTypes from 'prop-types';
import React from 'react';
import Icon from './../Icon';

const Switch = ({ selected, label, onChange, color, size, description, togglePosition, variant }) => {
  const [animation, setAnimation] = React.useState(0);
  const toggleOnIcon = variant === 'inline' ? 'toggle-on' : 'switch-on';
  const toggleOffIcon = variant === 'inline' ? 'toggle-off' : 'switch-off';

  function handleClick(e) {
    onChange(e, !selected);
    setAnimation(1);
  }

  return (
    <div
      className={`switch switch--color-${color} ${selected ? 'switch--selected' : ''}`}
      onClick={handleClick}
      onAnimationEnd={() => setAnimation(0)}
      animation={animation}
    >
      {togglePosition === 'left' && (
        <div className="switch__icon">
          <Icon type={selected ? toggleOnIcon : toggleOffIcon} color={selected ? 'primary' : 'default'} size={size} />
        </div>
      )}
      {(label || description) && (
        <div className="switch__texts">
          {label && (
            <label title={label} className="switch__label">
              {label}
            </label>
          )}
          {description && (
            <span title={description} className="switch__description">
              {description}
            </span>
          )}
        </div>
      )}
      {togglePosition === 'right' && (
        <div className="switch__icon">
          <Icon type={selected ? toggleOnIcon : toggleOffIcon} color={selected ? 'primary' : 'default'} size={size} />
        </div>
      )}
    </div>
  );
};

Switch.propTypes = {
  selected: PropTypes.bool,
  text: PropTypes.string,
  onChange: PropTypes.func,
  color: PropTypes.oneOf(['default', 'light']),
  size: PropTypes.oneOf(['default', 'big', 'big-2', 'xl', 'xxl']),
  description: PropTypes.string,
  togglePosition: PropTypes.oneOf(['left', 'right']),
  label: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'inline']),
};

Switch.defaultProps = {
  selected: false,
  text: '',
  onChange: function () {},
  color: 'default',
  size: 'default',
  togglePosition: 'left',
  variant: 'default',
};

export default Switch;
